import { Link } from 'react-router-dom';

interface UserConfigItemProps {
  title: string;
  linkTo?: string;
  popoverComponent?: React.ComponentType<{ children: React.ReactNode }>;
  count?: number;
}

export const UserConfigItem = ({
  title,
  linkTo,
  popoverComponent: Popover,
  count,
}: UserConfigItemProps) => {
  const content = (
    <div className={`flex h-full cursor-pointer items-center gap-[4px] text-gr-900 Body5M14 `}>
      <span className="truncate">{title}</span>
      <span className="truncate">{count}</span>
    </div>
  );

  if (Popover) {
    return <Popover>{content}</Popover>;
  }

  if (linkTo) {
    return <Link to={linkTo}>{content}</Link>;
  }

  return content;
};
